<p-table
  [value]="insiderData"
  [paginator]="insiderData.length > 0"
  [rows]="5"
  [tableStyle]="{ 'min-width': '50rem' }"
  dataKey="asReportedInsiderId"
>
  <ng-template #header>
    <tr>
      <th>A R. ID</th>
      <th>Insider Name</th>
      <th>Reporting Entity Name</th>
      <th>Reporting Entity Type</th>
      <th>Insider Role In Entity</th>
      <th>CIK</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-insider>
    <tr [pSelectableRow]="insider">
      <td>{{ insider.asReportedInsiderId || "N/A" }}</td>
      <td>{{ insider.asReportedInsiderName || "N/A" }}</td>
      <td>{{ insider.asReportedReportingEntityName || "N/A" }}</td>
      <td>{{ insider.asReportedReportingEntityType || "N/A" }}</td>
      <td>{{ insider.asReportedInsiderRoleInEntity || "N/A" }}</td>
      <td>{{ insider.insiderCik || "NA" }}</td>
      <td>
        <div>
          <button
            (click)="onRevertInsider(insider)"
            class="bg-red-600 text-white cursor-pointer py-1 px-3 rounded hover:bg-red-700 transition-colors"
          >
            Revert
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="noRecord">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>

<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
